import { View } from "@react-pdf/renderer";
import { DemonstrativoReceitaEDespesaItem } from "core/features/relatorios/typings/index";
import { PDFTable } from "ui/components/PDF";
import useRelatorioDemonstrativoReceitaDespesaPdfColumns from "./hooks/useRelatorioDemonstrativoReceitaDespesaPdfColumns";

interface PDFDemonstrativoReceitaEDespesaTableProps {
  items: DemonstrativoReceitaEDespesaItem[];
  tableTitle: string;
  noPercentage?: boolean;
  somarSubcategorias?: boolean;
}

function OperacaoTable({
  items,
  tableTitle,
  noPercentage,
  somarSubcategorias,
}: PDFDemonstrativoReceitaEDespesaTableProps) {
  const columns = useRelatorioDemonstrativoReceitaDespesaPdfColumns({
    title: tableTitle,
    noPercentage,
    somarSubcategorias,
  });

  return (
    <View>
      <PDFTable data={items} columns={columns} tableHeaderVariant="primary" />
    </View>
  );
}

export default OperacaoTable;
